import * as React from "react";
import { Select } from "antd";
import { States } from "../../../util/countries";
import {
  defaultSelectFilterOption,
  defaultSelectFilterSort,
} from "../../../util/utils";
import "./StateDropdown.scss";

const { Option } = Select;

interface StateDropdownProps {
  onChange: (value: string) => void;
  defaultValue: string;
  tabIndex?: number;
  className?: string;
}

export default function StateDropdown({
  onChange,
  tabIndex,
  defaultValue,
  className,
}: StateDropdownProps) {
  return (
    <Select
      defaultValue={defaultValue}
      tabIndex={tabIndex}
      size={"large"}
      onChange={onChange}
      className={`state-dropdown ${className}`}
      key={defaultValue}
      showSearch
      optionFilterProp="children"
      filterOption={defaultSelectFilterOption}
      filterSort={defaultSelectFilterSort}
    >
      <Option value={""} disabled={true}>
        Select State
      </Option>
      {Object.keys(States).map((it) => (
        <Option key={it} value={it}>
          {it}
        </Option>
      ))}
    </Select>
  );
}
